import getters from './contactsGetters'
import mutations from './contactsMutations'
import state from './contactsState'
import actions from './contactsActions'

export default {
  namespaced: true,
  getters,
  actions,
  state,
  mutations,
}
